import { render, staticRenderFns } from "./ETPraticaDocuments.vue?vue&type=template&id=4ef1d7fc&scoped=true&"
import script from "./ETPraticaDocuments.vue?vue&type=script&lang=js&"
export * from "./ETPraticaDocuments.vue?vue&type=script&lang=js&"
import style0 from "./ETPraticaDocuments.vue?vue&type=style&index=0&id=4ef1d7fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ef1d7fc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4ef1d7fc')) {
      api.createRecord('4ef1d7fc', component.options)
    } else {
      api.reload('4ef1d7fc', component.options)
    }
    module.hot.accept("./ETPraticaDocuments.vue?vue&type=template&id=4ef1d7fc&scoped=true&", function () {
      api.rerender('4ef1d7fc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/elements/pratica/express-trailers/ETPraticaDocuments.vue"
export default component.exports